import { layerStorageKey } from '../../components/Others/layerControl/utils';
import { pipe } from './compose';
import store from '../../global-state/redux';

const COOKIE_NAME_FALLBACK = 'vsx_cookie';
const cookieToKeepList = ['externalAuthorizationCode'];
const storageToKeepList = [layerStorageKey, 'adminLoginInfo', 'previousLocation', 'splashScreenShowCount'];

const getCookieBannerName = () => {
  const modules = store.getState()?.appState?.settings?.modules ?? {};
  const cookieBannerModule = Object.values(modules).find(
    (m) => m?.componentsToCore?.some?.((c) => c.componentName === 'CookieBanner')
  );
  return cookieBannerModule?.settings?.cookieName || COOKIE_NAME_FALLBACK;
};

const byToRemove = (arr) => (el) => !arr.includes(el);

function getCookieKeyList() {
  return document.cookie
    .split(';')
    .map((el) => el.split('=', 1))
    .flat()
    .map((el) => el.trim());
}

function resetCookie(key) {
  // we do not manage cookies set with other values in the path then '/'.
  // This should be addressed at some point.
  document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

const getLocalStorageKeyList = () => {
  const keyList = [];

  for (let i = 0; i < localStorage.length; i++) {
    keyList.push(localStorage.key(i));
  }

  return keyList;
};

export function clearCookies() {
  const dynamicKeepList = [...cookieToKeepList, getCookieBannerName()];
  const removeKeysToKeep = (list) => list.filter(byToRemove(dynamicKeepList));
  const clearCookeByKey = (list) => list.forEach(resetCookie);

  pipe(getCookieKeyList, removeKeysToKeep, clearCookeByKey)();
}

export function clearStorage() {
  const removeKeysToKeep = (list) => list.filter(byToRemove(storageToKeepList));
  const clearStorageByKey = (list) => list.forEach((el) => localStorage.removeItem(el));

  pipe(getLocalStorageKeyList, removeKeysToKeep, clearStorageByKey)();
}
